import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

type SlickSliderProps = {
  children?: React.ReactNode;
};

// Slick slider component to handle autopla

const AutoPlay = ({ children }: SlickSliderProps) => {
  const settings = {
    dots: true,
    arrows: true,
    centerMode: false,
    infinite: false,
    slidesToShow: 3.5,
    slidesToScroll: 3.5,
    autoplay: false,
    speed: 200,
    autoplaySpeed: 1000,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 2.5,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplaySpeed: 2000,
          infinite: false,
          dots: true,
          autoplay: false,
        },
      },
    ],
  };

  return (
    <div className="slider-container">
      <Slider {...settings}>{children}</Slider>
    </div>
  );
};

export default AutoPlay;
